module.exports = __webpack_public_path__ + "img/wisepoe.5094c7fc.png";